/*
 * @Author: Json Chen
 * @Date: 2022-06-15 08:55:01
 * @LastEditTime: 2022-06-16 15:07:39
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/hooks/permissions.ts
 */

import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';

export const discountPermissions = (uuid: string) => {
  const view_all_discounts_listing_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelDiscount,
        subCategory: EnumSubCategory.ChannelDiscount,
        operation: EnumOperation.view_all_discounts_listing_page,
        uuid,
      }),
    ],
  });
  const view_discount_details_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelDiscount,
        subCategory: EnumSubCategory.ChannelDiscount,
        operation: EnumOperation.view_discount_details_page,
        uuid,
      }),
    ],
  });
  const add_edit_discount = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelDiscount,
        subCategory: EnumSubCategory.ChannelDiscount,
        operation: EnumOperation.add_edit_discount,
        uuid,
      }),
    ],
  });
  const archive_discount = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelDiscount,
        subCategory: EnumSubCategory.ChannelDiscount,
        operation: EnumOperation.archive_discount,
        uuid,
      }),
    ],
  });
  return {
    canViewList: view_all_discounts_listing_page,
    canViewDetail: view_discount_details_page,
    canEdit: add_edit_discount,
    canDelete: archive_discount,
  };
};
